var Component = require("!../../../../node_modules/.11.1.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=script&index=0!./message.vue"),
  /* template */
  require("!!../../../../node_modules/.11.1.4@vue-loader/lib/template-compiler?{\"id\":\"data-v-acdcfa4e\"}!../../../../node_modules/.11.1.4@vue-loader/lib/selector?type=template&index=0!./message.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/packages/message/src/message.vue
// module id = 197
// module chunks = 0